/**
 * 권한 이름. 서버 `us_api/web/api/auth/rbac.py` 의 `Permission` 과 **1:1** 이다.
 * 문자열이 갈라지면 조용히 권한이 사라지므로 한쪽을 고치면 반드시 양쪽을 고친다.
 *
 * 등급(`basic`/`pro`/`elite`/`admin`)은 여기에 나오지 않는다. 화면은 등급을 묻지 않고
 * **행위**를 묻는다 — 등급 정책이 바뀌어도 화면 코드는 그대로다.
 */
export const PERMISSIONS = {
  /** ETF·주식 목록과 백테스트의 국가/통화 선택 */
  COUNTRY_FILTER: 'country.filter',
  /** 지수 전체 목록. 없으면 서버가 공개 티커만 내려준다 */
  INDEX_FULL: 'index.full',
  /** 부동산 데이터 */
  REALTY_VIEW: 'realty.view',
  /** 기초자산 정보 표 */
  ASSET_UNDERLYING: 'asset.underlying',
  /** 각종 엑셀 다운로드 */
  DOWNLOAD_EXCEL: 'download.excel',
  /** 백테스트 배당세 반영 */
  BACKTEST_AFTER_TAX: 'backtest.aftertax',
  /** 백테스트 전략 5개 제한 해제 */
  BACKTEST_UNLIMITED: 'backtest.unlimited',
  /**
   * 어드민 화면 (유저 관리 · 멤버십 관리).
   *
   * 서버에서 **admin 등급만** 새로 여는 권한이다. `permissions_of` 는 자기 rank
   * 이하만 누적하므로 elite 가 물려받지 않는다. 화면을 감추는 것만으로는 URL 을
   * 직접 치면 열리므로 라우트도 `RequirePermission` 으로 감싸고, 서버도 따로 막는다.
   */
  ADMIN_PANEL: 'admin.panel',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
